import { CheckBox, HtmlEditor } from "devextreme-react";
import { GroupItem } from "devextreme-react/form";
import { Form, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { EmailTemplate } from "./type";

const EmailTemplateDetail = forwardRef<any, { data: EmailTemplate }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized)
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                label={{ text: localize.getString("name") }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Active"}
                label={{ text: localize.getString("isActive") }}
                render={(e: any) => {
                    return <CheckBox
                        value={data.Active}
                        disabled={true}
                    ></CheckBox>
                }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"EmailTemplateType"}
                label={{ text: localize.getString("emailTemplateType") }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Template"}
                label={{ text: localize.getString("template") }}
                render={(e: any) => {
                    return <HtmlEditor
                        defaultValue={data.Template}
                        disabled={true}
                    >

                    </HtmlEditor>
                }}
            >

            </SimpleItem>
        </GroupItem>
    </Form>
})

export default EmailTemplateDetail